//ex组件公共样式
import '@/styles/ex.scss'
//导出ex公共组件才能注册全局组件
import EXArticle from "./EXArticle";
import EXMainTitle from "./EXArticle/mainTitle";
import EXProcess from "./EXProcess";
import EXCharts from "./EXCharts";
import EXDetailContent from "./EXDetail/EXDetailContent";
import EXHeader from "./EXDetail/EXHeader";
import EXNavList from "./EXDetail/EXNavList";
import EXDialog from "./EXDialog"
import EXChooseAddress from "./EXDialog/EXChooseAddress";
import EXChooseDepartment from "./EXDialog/EXChooseDepartment";
import EXChoosePerson from "./EXDialog/EXChoosePerson";
import EXConfirmDialog from "./EXDialog/EXConfirmDialog";
import EXImportDialog from "./EXDialog/EXImportDialog";
import EXAttachsDialog from "./EXDialog/EXAttachsDialog";
import EXForm from "./EXForm";
import EXSelect from "./EXForm/EXSelect";
import EXSelectTree from "./EXForm/EXSelectTree";
import EXCheckButton from "./EXForm/EXCheckButton";
import EXHoverTitle from "./EXHoverTitle";
import EXNodata from "./EXNodata";
import EXPagination from "./EXPagination";
import EXPreview from "./EXPreview";
import EXSearchHead from "./EXSearchHead";
import EXStatDateSearch from "./EXSearchHead/statDateSearch";
import EXTable from "./EXTable";
import EXTableColumn from "./EXTable/EXTableColumn";
import EXMultiTable from "./EXTable/multiTable";
import EXTableTopBtnDesc from "./EXTable-top-btn-desc";
import EXTabs from "./EXTabs";
import ETree from "./EXTree/tree";
import EXTree from "./EXTree";
import EXUploadImg from "./EXUpload/uploadImg";
import EXUploadFile from "./EXUpload/uploadFile";
import EXUploadFile2 from "./EXUpload/uploadFile2";
import EXStageBox from "./EXStageBox";
//ex函数公共方法
import mixin from '@/mixins/mixin'
window.EXMixin = mixin
import getList from '@/mixins/getList'
window.EXList = getList
import getMultiList from '@/mixins/getMultiList'
window.EXMultiList = getMultiList
import getTree from '@/mixins/getMultiTree'
window.EXTree = getTree

export default {
  install: (Vue) => {
    Vue.component('EXArticle', EXArticle)
    Vue.component('EXMainTitle', EXMainTitle)
    Vue.component('EXProcess', EXProcess)
    Vue.component('EXCharts', EXCharts)
    Vue.component('EXDetailContent', EXDetailContent)
    Vue.component('EXHeader', EXHeader)
    Vue.component('EXNavList', EXNavList)
    Vue.component('EXDialog', EXDialog)
    Vue.component('EXChooseAddress', EXChooseAddress)
    Vue.component('EXChooseDepartment', EXChooseDepartment)
    Vue.component('EXChoosePerson', EXChoosePerson)
    Vue.component('EXConfirmDialog', EXConfirmDialog)
    Vue.component('EXImportDialog', EXImportDialog)
    Vue.component('EXAttachsDialog', EXAttachsDialog)
    Vue.component('EXForm', EXForm)
    Vue.component('EXSelect', EXSelect)
    Vue.component('EXSelectTree', EXSelectTree)
    Vue.component('EXCheckButton', EXCheckButton)
    Vue.component('EXHoverTitle', EXHoverTitle)
    Vue.component('EXNodata', EXNodata)
    Vue.component('EXPagination', EXPagination)
    Vue.component('EXPreview', EXPreview)
    Vue.component('EXSearchHead', EXSearchHead)
    Vue.component('EXStatDateSearch', EXStatDateSearch)
    Vue.component('EXTable', EXTable)
    Vue.component('EXTableColumn', EXTableColumn)
    Vue.component('EXMultiTable', EXMultiTable)
    Vue.component('EXTableTopBtnDesc', EXTableTopBtnDesc)
    Vue.component('EXTabs', EXTabs)
    Vue.component('ETree', ETree)
    Vue.component('EXTree', EXTree)
    Vue.component('EXUploadImg', EXUploadImg)
    Vue.component('EXUploadFile', EXUploadFile)
    Vue.component('EXUploadFile2', EXUploadFile2)
    Vue.component('EXStageBox', EXStageBox)
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js